import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Departments Redux States
import {
  GET_DEPARTMENTS,
  GET_DEPARTMENT,
  CREATE_DEPARTMENT,
  EDIT_DEPARTMENT,
  DELETE_DEPARTMENT,
} from "./actionTypes";
import {
  setDepartments,
  apiError,
  setDepartment,
  createDepartmentSuccess,
  editDepartmentSuccess,
  deleteDepartmentSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getDepartments({
  payload: { idCompany, page, qnt, name, email, slug, isForm },
}) {
  try {
    const response = yield call(
      axios.get,
      `/department?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (page ? `&page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "") +
        (email ? `&email=${email}` : "") +
        (slug ? `&slug=${slug}` : "") +
        (isForm ? `&form=${isForm}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setDepartments(response.data.data, qnt, idCompany));
    } else throw response.data;
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createDepartment({ payload: { newDepartmentValues, idCompany } }) {
  try {
    const response = yield call(
      axios.post,
      `/department?${idCompany ? `client_id=${idCompany}` : ""}`,
      newDepartmentValues
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(createDepartmentSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* getDepartment({ payload: { idDepartment, idCompany, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/department?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (idDepartment ? `&id=${idDepartment}` : "") +
        (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setDepartment(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editDepartment({
  payload: { idDepartment, newDepartmentValues, idCompany },
}) {
  try {
    const response = yield call(
      axios.patch,
      `/department?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (idDepartment ? `&id=${idDepartment}` : "")
      }`,
      newDepartmentValues
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(editDepartmentSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deleteDepartment({ payload: { idDepartment, idCompany } }) {
  try {
    const response = yield call(
      axios.delete,
      `/department?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (idDepartment ? `&id=${idDepartment}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message ? response.data.message : "";
      yield put(deleteDepartmentSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

export function* watchDepartment() {
  yield takeEvery(GET_DEPARTMENTS, getDepartments);
}
export function* watchGetDepartment() {
  yield takeEvery(GET_DEPARTMENT, getDepartment);
}
export function* watchCreateDepartment() {
  yield takeEvery(CREATE_DEPARTMENT, createDepartment);
}
export function* watchEditDepartment() {
  yield takeEvery(EDIT_DEPARTMENT, editDepartment);
}
export function* watchDeleteDepartment() {
  yield takeEvery(DELETE_DEPARTMENT, deleteDepartment);
}
function* authSaga() {
  yield all([
    fork(watchDepartment),
    fork(watchGetDepartment),
    fork(watchCreateDepartment),
    fork(watchEditDepartment),
    fork(watchDeleteDepartment),
  ]);
}

export default authSaga;
